export const fr = {
    translations: {
        values: {
            one: "un",
            two: "deux",
            three: "trois",
            four: "quatre",
            five: "cinq",
            six: "six",
            seven: "sept",
            eight: "huit",
            nine: "neuf",
            redFive: "cinq rouge",
            east: "vent est",
            south: "vent sud",
            west: "vent ouest",
            north: "vent nord",
            white: "dragon blanc",
            green: "dragon vert",
            red: "dragon rouge",
            hidden: "tuile cachée",
        },
        suits: {
            characters: "caractères",
            circles: "cercles",
            bamboo: "bambous"
        },
        shuupai: "{{value}} de {{suit}}",
        winds: {
            east: "Est",
            south: "Sud",
            west: "Ouest",
            north: "Nord"
        },
        roundName: "{{wind}} {{number}}-{{repeats}}",
        trainer: {
            disclaimer: "Avertissement : Ce programme sert à entraîner votre capacité à maximiser l'efficacité de votre main dans une main. Cela ne vous aidera pas à maximiser votre efficacité dans les mains futures, ni à apprendre quand il convient d'ignorer l'efficacité ou comment créer de la valeur. Jouer comme ce programme le suggère dans chaque main n'est pas la meilleure façon de jouer au mahjong, mais certaines mains vous demanderons d'être capable de jouer de cette façon. Les joueurs de haut niveau ne jouent pas toujours comme ça, mais tous les joueurs de haut niveau PEUVENT jouer comme ça. Assurez-vous de compléter cette formation par une plus ample documentation pour savoir quand ce n'est pas la meilleure stratégie, et vérifiez les réglages pour un entraînement plus ciblé.",
            instructions: "Cliquez sur la tuile que vous souhaitez défausser.",
            start: "Vous avez débuté une nouvelle main : {{hand}}",
            complete: " Votre main est maintenant prête. Félicitation ! Votre efficacité a été de {{achieved}}/{{total}}, soit {{percent}}%.",
            newHandButtonLabel: "Nouvelle main",
            loadButtonLabel: "Charger une main",
            roundWind: "Vent du tour :",
            seatWind: "Vent du joueur :",
            doraIndicator: "Indicateur de dora :",
            copyHand: "Copier la main",
            copied: "Copié !",
            error: {
                load: "Erreur : Impossible de comprendre la main fournie.",
                wallEmpty: "Erreur : Pas assez de tuiles pour former une main.",
                wallEmptyShuffle: "Il ne reste plus assez de tuiles dans le mur pour former une main. Mélange en cours..."
            },
            playerNames: {
                you: "Vous",
                right: "Shimocha",
                across: "Toimen",
                left: "Kamicha"
            }
        },
        history: {
            label: "Historique des mains",
            tenhouLinkText: "[Tuiles acceptées]",
            concise: {
                discard: "Défausse : {{tile}}",
                acceptance: " ({{count}} tuile).",
                acceptance_plural: " ({{count}} tuiles).",
                loweredShanten: " (a abaissé le shanten).",
                optimal: " Meilleur :",
                optimalSpoiler: " {{tile}}",
                best: " Il s'agissait du meilleur choix !",
                exceptionalNoten: " Toutes vos tuiles gagnantes se trouvent dans votre main ; vous n'êtes donc pas encore tenpai.",
                furiten: " Furiten.",
                furitenWarning: " Méfiez-vous d'un furiten à venir.",
                exhausted: " Il ne reste plus aucune tuile dans le mur. Vous aurez plus de chance la prochaine fois ! ",
                draw: " Pioche : {{tile}}. "
            },
            verbose: {
                discard: "Vous avez choisi de défausser le {{tile}}, ce qui",
                acceptance: " laisse {{count}} tuile pouvant améliorer votre main.",
                acceptance_plural: " laisse {{count}} tuiles pouvant améliorer votre main.",
                loweredShanten: " a abaissé votr shanten ; votre main est maintenant plus loin d'être prête.",
                optimal: " La tuile la plus efficace à défausser",
                optimalSpoiler: ", le {{tile}}, ",
                best: " Il s'agissait du meilleur choix !",
                exceptionalNoten: " Votre main est prête, mais toutes vos tuiles gagnantes sont dans votre main. Cela ne compte pas comme prêt dans presque toutes les règles, vous devrez donc changer votre main.",
                furiten: " Vous êtes en état de furiten. Vous ne pouvez pas gagner cette main par ron, car l'une de vos tuiles gagnantes se trouve dans votre défausse.",
                furitenWarning: " Méfiez-vous d'un futur furiten. Certaines tuiles qui amélioreraient votre main sont déjà dans votre défausse.",
                exhausted: " Il ne reste plus aucune tuile dans le mur. Vous aurez plus de chance la prochaine fois ! ",
                draw: " Vous avez pioché un {{tile}}. "
            }
        },
        discards: {
            label: "Défausse",
            discardCount: "Vous avez défaussé {{count}} tuile.",
            discardCount_plural: "Vous avez défaussé {{count}} tuiles.",
            tilesLeft: "Il reste {{count}} tuile dans le mur.",
            tilesLeft_plural: "Il reste {{count}} tuiles dans le mur."
        },
        settings: {
            buttonLabel: "Réglages",
            tilesAllowed: "Tuiles autorisées :",
            characters: "Caractères",
            circles: "Cercles",
            bamboo: "Bambous",
            honors: "Honneurs",
            sanma: "Règles du mahjong à 3 joueurs",
            redFives: "Nombre de cinq rouges:",
            verbose: "Nom complet des tuiles (\"un de bambou\" ou \"1s\")",
            showIndexes: "Afficher les étiquettes de tuile",
            concise: "Historique abrégé",
            spoilers: "Montrer quelle était la meilleure option",
            shuffle: "Remélanger les tuiles défaussées dans le mur avant de commencer une nouvelle main",
            simulate: "Simuler les défausses d'autres joueurs",
            exceptions: "Prendre en compte les exceptions (Kokushi/Treize Orphelins et Chiitoitsu/Sept Paires)",
            minShanten: "Shanten minimal de départ :",
            minShantenLimit: "(maximum : nombre de familles autorisées)",
            sort: "Trier la main",
            blind: "Cacher les tuiles de la main",
            useTimer: "Activer la minuterie",
            time: "Temps pour défaussé:",
            extraTime: "Temps bonus pour main:",
            seconds: "secondes"
        },
        stats: {
            buttonLabel: "Statistiques",
            info: "Ces statistiques sont mises à jour à chaque fois que vous formez une main prête",
            ready: "Mains prêtes : {{count}} main",
            ready_plural: "Mains prêtes : {{count}} mains",
            discards: "Tuiles défaussées : {{count}} tuile",
            discards_plural: "Tuiles défaussées : {{count}} tuiles",
            average: "Moyenne de défausses avant tenpai : {{average}} défausses",
            optimal: "Défausses optimales : {{count}} défausse",
            optimal_plural: "Défausses optimales : {{count}} défausses",
            optimalRate: "Taux de défausses optimales : {{percent}}% ({{achieved}}/{{total}})",
            efficiency: "Éfficacité acquise: {{count}} tuile",
            efficiency_plural: "Éfficacité acquise: {{count}} tuiles",
            possible: "Éfficacité potentiellement acquérable : {{count}} tuile",
            possible_plural: "Éfficacité potentiellement acquérable : {{count}} tuiles",
            overall: "Éfficacité globale : {{percent}}% ({{achieved}}/{{total}})",
            reset: "Réinitialiser les statistiques",
            confirmation: "Êtes-vous certain de vouloir remettre les statistiques à zéro ? Cette action est irréversible.",
            yes: "Oui, réinitialiser !",
            no: "Non, ne pas réinitialiser !"
        },
        credits: {
            label: "Crédits",
            tilesPreLink: "Les images des tuiles proviennent de ",
            tilesLinkText: "riichi-mahjong-tiles par FluffyStuff sur Github",
            tilesPostLink: ", sous licence ",
            ccLinkText: "Creative Commons Attribution 4.0 International License.",
            shantenPreLink: "Algorithme de calcul de shanten adapté d'après ",
            shantenLinkText: "cet ensemble de programmes C.",
            shantenPostLink: "",
        },
        menu: {
            trainer: "Entraînement",
            analyzer: "Analyse",
            allLast: "Entraînement Oorasu",
            explorer: "Explorateur",
            utils: "Utilitaires",
            language: "Langue",
            defense: "Betaori"
        },
        allLast: {
            placements: {
                first: "premier",
                second: "deuxième",
                third: "troisième",
                fourth: "quatrième"
            },
            title: "Entraînement Oorasu",
            maxFu: "Fu maximal",
            showDifferences: "Montrer les différences de points",
            loadInstructions: "Entrez les scores de Est, Sud, Ouest et Nord, dans cet ordre, séparés par des virgules pour initialiser une situation.",
            loadLabel: "Charger une situation",
            newLabel: "Nouvelle situation aléatoire",
            info: "C'est le Oorasu, la dernière main de la partie. Vous êtes à la quatrième place. Les scores sont comme suit :",
            escapeHeader: "Éviter la quatrième place",
            riichiHeader: "Déclarations de riichi",
            higherHeader: "Bonnes positions",
            question: "Quel est le score minimum que vous devez marquer par {{action}} afin de vous placer en {{placement}} ?",
            riichiQuestion: "Si {{player}} déclare riichi, quel est le score minimum que vous devez marquer par {{action}} afin de vous placer en {{placement}} position ?",
            ron: "ron {{target}} avec ",
            tsumo: "tsumo",
            han: "Han",
            fu: "Fu",
            submit: "Vérifier",
            wrong: "Faux ! Ce score ne vous amène pas en {{placement}} position ! Surlignez pour avoir la réponse : ",
            tooMuch: "Ce score vous amène en {{placement}} position, mais ce n'est pas le plus bas possible. Surlignez pour avoir la réponse : ",
            correct: "Correct ! Il s'agit du score le plus bas qui vous amène en {{placement}} position !",
            score: "{{han}} han {{fu}} fu",
            results: "Résultats :",
            you: "VOUS",
            error: {
                few: "Erreur : Il n'y a pas assez de scores.",
                NaN: "Erreur : Impossible de comprendre le score de {{seat}}."
            }
        },
        analyzer: {
            instructions1: "Instructions :",
            instructions2: "Copiez l'URL de votre replay dans le champ.",
            instructions3: 'Puis, faites un clic droit sur le lien qui apparaît et choisissez "Enregistrer sous..." ou "Enregistrer la cible du lien sous...".',
            instructions4: 'Enfin, cliquez sur "Parcourir..." pour charger le fichier qui vous avez enregistré.',
            instructions5: "Alternativement, si vous avez un fichier mjlog sur votre ordinateur, vous pouvez le renommer pour remplacer son extension par.zip",
            instructions6: "Puis, chargez le fichier contenu dans cette archive ZIP.",
            instructions7: "Vous pouvez également charger directement les fichiers XML de replay si vous avez un programme qui les récupère pour vous.",
            instructions8: "L'avertissement de l'entraînement à l'efficacité s'appique aussi ici",
            instructions9: "Pour les évaluations de sécurité, plus la cote est élevée, mieux c'est. 1 est le pire, et 15 est le meilleur.",
            URLplaceholder: "URL de replay",
            invalidURL: "URL invalide",
            downloadInstructions: "Faites un clic droit sur ce lien et sélectionnez \"Enregistrer sous...\" !",
            roundSelect: "Sélectionner une main",
            playerSelect: "Changer de joueur",
            previousTurn: "Tour précédent",
            nextTurn: "Tour suivant",
            nextIssue: "Prochain point",
            turn: "{{round}}, Tour {{turn}}",
            discards: "Tuiles dans votre défausse : {{symbols}} ({{tiles}})",
            calls: "Vos appels : {{calls}}",
            callsSeparator: ", ",
            tenhouLinkText: "[Analyse de l'ukeire par Tenhou]",
            replayError: "Quelque chose s'est mal déroulé. Envoyez-moi ce replay.",
            noName: "Inconnu",
            startingHand: "Votre main de départ est {{hand}}. Elle est à {{count}} tuile d'être prête. L'indicateur de dora est {{dora}}.",
            startingHand_plural: "Votre main de départ est {{hand}}. Elle est à {{count}} tuiles d'être prête. L'indicateur de dora est {{dora}}.",
            unknownAction: "Hé ! Ce replay a quelque chose d'imprévu. Merci de me l'envoyer afin que je puisse y remédier. {{debugInfo}}",
            call: "Vous avez appelé le {{tile}} pour compléter {{meld}}. ({{hand}})",
            callSameShanten: "Cet appel ne vous a pas rapproché de tenpai.",
            ryuukyoku: "La main est nulle.",
            playerRiichi: "Vous avez déclaré riichi. Fin de l'analyse.",
            otherRiichi: "Le joueur {{number}} a déclaré riichi. ",
            fold: "Vous êtes encore à {{shanten}} tuiles de tenpai. Vous devriez vous coucher.",
            probablyFold: "Vous êtes à une tuile de tenpai. Vous devriez envisager de vous coucher.",
            win: "Le joueur {{number}} a remporté la main.",
            kandora: "Le nouvel indicateur de dora est le {{tile}}.",
            draw: "Vous avez pioché le {{tile}}. ({{hand}})",
            chosenSafety: "Le taux de sûreté du {{tile}} est de {{rating}}. ({{- explanation}}) ",
            correctSafety: "Il s'agissait de la tuile la plus sûre.",
            bestSafety: "Tuile la plus sûre : {{tile}}, avec un taux de sûreté de {{rating}}. ({{- explanation}})",
            safetyExplanations: {
                zero: "Vous n'êtes pas censé voir ce message. Prévenez-moi, le cas échéant.",
                one: "non-suji 4/5/6",
                two: "non-suji 3/7",
                three: "non-suji 2/8",
                four: "une seule chance",
                five: "non-suji 1/9",
                six: "premier honneur",
                seven: "suji 3/7",
                eight: "suji 2/8",
                nine: "suji 4/5/6",
                ten: "deuxième honneur",
                eleven: "première terminale suji",
                twelve: "deuxième terminale suji",
                thirteen: "troisième terminale suji / troisième honneur",
                fourteen: "quatrième terminale suji / quatrième honneur",
                fifteen: "genbutsu, 100% sûr"
            }
        },
        explorer: {
            warning: "Avertissement : Le chargement d'une main peut causer un ralentissement de la page de 5 à 10 secondes, voire plus si vous avez un ordinateur plus ancien, selon la complexité de la main. Charger une main montrera tous les ukeire et possibilités d'amélioration pour chaque défausse, y compris celles qui augmentent le shanten. Par défaut, les options qui sont plus mauvaises ne seront pas affichées, mais vous pouvez appuyer sur le bouton ci-dessous pour changer cela. Si vous n'avez besoin que de l'ukeire, tenhou.net/2/ suffit.",
            shanten: "Shanten : Le nombre de tuiles qu'il vous manque pour être tenpai.",
            ukeire: "Ukeire : Le nombre de tuiles qui réduisent votre shanten.",
            notableDiscards: "Afficher uniquement les défausses significatives",
            allDiscards: "Afficher toutes les défausses possibles",
            discardInfo: {
                discard: "Défausse du {{tile}} :",
                shanten: "Shanten : {{count}}",
                ukeire: "Ukeire : {{count}} ({{tiles}})",
                expand: "Afficher l'ukeire du prochain shanten",
                draw: "Piocher le {{draw}}, défausser le {{discard}}: {{count}} ukeire",
                average: "Moyenne : {{average}}",
                upgrades: "Tuiles qui augmentent l'ukeire : {{count}} ({{tiles}})",
                expandUpgrades: "Afficher les améliorations"
            }
        },
        defense: {
            instructions: "Défausser la tuile la plus sûre.",
            finalHands: "Dernières mains:",
            hand: "{{player}}: {{hand}}",
            safetyRatings: "Le taux de sûreté",
            averagedSafetyRating: "Contre plusieurs riichis, les taux de sûreté seront moyennées, la plus haute étant choisie comme meilleure.",
            safetyRating: "{{rating}}: {{- explanation}}",
            riichiCount: "Nombre de riichis: ",
            minTurns: "Tours minimums avant qu'un riichi soit déclaré: ",
            tilesInHand: "Nombre de tuiles en main: "
        },
        utils: {
            convertHeader: "Conversion de main",
            convertButtonLabel: "Convertir une main",
            ascii: "ASCII :",
            emoji: "Emoji :",
            stateHeader: "Générateur de situation de jeu aléatoire",
            playerLabel: "{{seat}} Joueur {{you}}",
            points: "Points :",
            discards: "Défausses :",
            stateButtonLabel: "Générer une nouvelle situation",
            info: "C'est le tour {{turn}} de la manche {{round}}. Vous êtes le joueur {{seat}}.",
            dora: "L'indicateur de dora est le {{tile}}."
        }
    }
}
